const settings = {
  allow: {
    add_goods: "allow_add_goods",
    edit_users: "edit_users_allowed",
    empty_booking_reference_1: "allow_empty_reference_1",
    empty_contact_person: "allow_empty_contact_person",
    empty_contact_phone: "allow_empty_contact_phone",
    empty_goods_reference: "allow_empty_goods_reference"
  },
  booking_type: "booking_type",
  default: {
    allow_no_signature: "default_allow_no_signature",
    goods: {
      cll: "default_goods_cll",
      weight: "default_goods_weight",
      description: "default_goods_description",
      unit_type: "default_goods_unit_type"
    },
    name: "default_name",
    notification_to_booker: "default_notification_to_booker",
    photo_documentation: "default_photo_documentation",
    vehicle_type: "default_vehicle_type"
  },
  hide: {
    address_info: "hide_address_info",
    booking: {
      notifications: "hide_booking_notifications",
      insurance: "hide_booking_insurance",
      references: "hide_booking_references",
      remarks: "hide_booking_remarks"
    },
    contact: "hide_contact",
    goods: {
      adr: "hide_goods_adr",
      dimensions: "hide_goods_dimensions",
      pipes: "hide_goods_pipes",
      reference: "hide_goods_reference",
      slv: "hide_goods_slv",
      unit_type: "hide_goods_unit_type"
    },
    price: "hide_price"
  },
  own_address_editable: "own_address_editable",
  price_incl_vat: "prices_incl_vat",
  unit_types: "unittypes",
  use_own_address_as: "use_own_address_as",
  vehicle_types: "vehicle_types"
};

const constants = {
  address_types: {
    pickup: "Pickup",
    delivery: "Delivery"
  },
  authentication: {
    jwt: "gls_express_user_token"
  },
  autocomplete_services: {
    DAWA: "DAWA",
    GoogleMaps: "GoogleMaps"
  },
  booking_types: {
    courier: "COURIER",
    distribution: "DISTRIBUTION"
  },
  events: {
    received: "Modtaget",
    accepted: "Godkendt",
    rejected: "Afvist",
    unsuccesful: "Forgæves",
    arrival: "Ankomst",
    departure: "Afgang",
    delay: "Forsinkelse",
    waiting: "Ventetid",
    invoiced: "Faktureret"
  },
  price_status: {
    final: "FINAL",
    indicative: "INDICATIVE"
  },
  terminal_address_types: {
    inbound: 1,
    outbound: -1
  }
};

const mdi = {
  add: "mdi-plus-thick",
  close: "mdi-minus-thick",
  CO2: "mdi-molecule-co2",
  copy: "mdi-content-copy",
  discount: "mdi-sale",
  excel: "mdi-file-excel",
  help: "mdi-information-outline",
  inspect: "mdi-eye",
  open: "mdi-plus-thick",
  //remove: "mdi-delete",
  remove: "mdi-close-thick",
  swap: "mdi-swap-horizontal",
  track: "mdi-map-marker",
  user: {
    add: "mdi-account-plus",
    delete: "mdi-account-minus",
    edit: "mdi-account-edit",
    info: "mdi-account",
    password: "mdi-lock-reset"
  }
};

const help = {
  adr: "Farligt gods",
  account: "Vælg din ansvarlige afdeling",
  dimension: "Angiv dimensioner for hele godsmængden",
  photo_documentation: "Fotodokumentation ved levering af gods",
  reference_1: "Reference til faktura",
  slv: "Lufthavnsgods"
  //pickup: {
  //name: 'Afhentningsnavn',
  //  address: 'Afhentningsadresse',
  //address2: 'Afhentningsadresseinfo',
  //     contact: {
  //         name: 'Afhentningskontaktperson',
  //         phone: 'Afhentningskontakttlf.',
  //     },
  // },
  // delivery: {
  //     name: 'Leveringsnavn',
  //     address: 'Leveringsadresse',
  //     address2: 'Leveringsadresseinfo',
  //     contact: {
  //         name: 'Leveringskontaktperson',
  //         phone: 'Leveringskontakttlf.',
  //     },
  // }
};

const priceheaders = {
  description: "Beskrivelse",
  remark: "Bemærkning",
  price: "Pris",
  currency: "Valuta"
};

const errors = {
  account: "Afdeling mangler",
  delivery: {
    address: {
      address: "Leveringsaddresse mangler",
      coordinates: "Leveringsaddresse kan ikke genkendes",
      name: "Leveringsnavn mangler"
    },
    contact: {
      name: "Leveringskontaktperson mangler",
      phone: "Leveringskontakttlf. mangler"
    },
    timewindow: {
      from: {
        date: "Tidligst leveringsdato mangler",
        time: "Tidligst leveringstidspunkt mangler"
      },
      to: {
        date: "Senest leveringsdato mangler",
        time: "Senest leveringstidspunkt mangler"
      }
    }
  },
  excel: {
    field: {
      missing: "Felt mangler",
      not_valid: "Felt ikke gyldigt"
    },
    value: {
      not_valid: "ikke gyldig"
    }
  },
  goods: {
    adr: "UN-nr. mangler",
    cll: "Kll mangler",
    description: "Godsbeskrivelse mangler",
    missing: "Gods mangler",
    packing_group: "Emballagegruppe mangler",
    pipes: "Rør længde skal angives under dimensioner",
    reference: "Godsreference mangler",
    weight: "Godsvægt mangler"
  },
  insurance: {
    amount: "Forsikret beløb mangler"
  },
  notification: {
    booker_email: "Booker e-mail mangler"
  },
  pickup: {
    address: {
      address: "Afhentningsaddresse mangler",
      coordinates: "Afhentningsaddresse kan ikke genkendes",
      name: "Afhentningsnavn mangler"
    },
    contact: {
      name: "Afhentningskontaktperson mangler",
      phone: "Afhentningskontakttlf. mangler"
    },
    timewindow: {
      from: {
        date: "Tidligst afhentningsdato mangler",
        not_possible: "Tidligst afhentning kan ikke lade sig gøre",
        time: "Tidligst afhentningstidspunkt mangler"
      },
      to: {
        date: "Senest afhentningsdato mangler",
        time: "Senest afhentningstidspunkt mangler"
      }
    }
  },
  reference_1: "Reference mangler",
  vehicle_type: {
    missing: "Biltype mangler",
    overload: {
      pallet_spaces: "Gods fylder for mange pallepladser til valgte biltype",
      pipes: "Valgte biltype kan ikke kører med rør",
      pipes_length: "Rør er for lange til valgte biltype",
      weight: "Gods er for tungt til valgte biltype",
      weight_lift: "Gods er for tungt til valgte biltypes lift"
    }
  }
};

const texts = {
  allow_no_signature: "Må stilles uden underskrift.",
  photo_documentation: "Husk billede af gods.",
  reset: {
    booking: {
      title: "Ryd bookingformular?",
      question: "Ønsker du at rydde bookingformular?"
    }
  }
};

export const dictionary = {
  settings,
  constants,
  mdi,
  help,
  priceheaders,
  errors,
  texts
};
